import React, { useCallback, useEffect, useState } from "react";

import { caApi } from "../../../backend_urls/caApi";

import DashboardWelcomeBanner from "./models/teams_model/DashboardWelcomeBanner";
import DashboardOverviewCards from "./models/teams_model/DashboardOverviewCards";
import DashboardAttentionPanel from "./models/teams_model/DashboardAttentionPanel";
import DashboardTeamHealth from "./models/teams_model/DashboardTeamHealth";
import DashboardProductivity from "./models/teams_model/DashboardProductivity";
import DashboardWorkingEmployees from "./models/teams_model/DashboardWorkingEmployees";
import DashboardTodayTasks from "./models/teams_model/DashboardTodayTasks";
import DashboardRecentActivity from "./models/teams_model/DashboardRecentActivity";

const initialDashboard = {
    summary: {
        employees: 0,
        working: 0,
        available: 0,
        break: 0,
        offline: 0,
        open_tasks: 0,
        completed_today: 0,
        overdue_tasks: 0,
    },
    employees: [],
    today_tasks: [],
    upcoming_tasks: [],
    recent_activities: [],
};

const CATeamsDashboard = () => {
    const [dashboard, setDashboard] = useState(initialDashboard);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadDashboard = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await caApi.getDashboard();

            setDashboard(response?.data || initialDashboard);
        } catch (err) {
            console.error("Failed to load team dashboard:", err);

            setError(
                err?.response?.data?.detail ||
                "Unable to load team dashboard."
            );
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { loadDashboard(); }, [loadDashboard]);

    if (loading) {
        return (
            <div style = {{ padding: "30px" }}>
                Loading team dashboard...
            </div>
        );
    }

    if (error) {
        return (
            <div style = {{ padding: "30px" }}>
                <div
                    style={{
                        padding: "20px",
                        borderRadius: "10px",
                        background: "#fef2f2",
                        color: "#b91c1c",
                    }}
                >
                    <strong>Unable to load dashboard</strong>
                    <p>{error}</p>

                    <button
                        onClick={loadDashboard}
                        style={{
                            padding: "8px 16px",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer",
                        }}
                    >
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
            <DashboardWelcomeBanner
                summary   = { dashboard.summary }
                onRefresh = { loadDashboard }
            />

            <DashboardOverviewCards
                summary = { dashboard.summary }
            />

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "20px",
                    marginBottom: "24px",
                }}
            >
                <DashboardAttentionPanel
                    summary    = { dashboard.summary }
                    todayTasks = { dashboard.today_tasks }
                />

                <DashboardTeamHealth
                    summary    = { dashboard.summary }
                    employees  = { dashboard.employees }
                    todayTasks = { dashboard.today_tasks }
                />
            </div>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "20px",
                    marginBottom: "24px",
                }}
            >
                <DashboardWorkingEmployees
                    employees = { dashboard.employees }
                />

                <DashboardProductivity
                    summary    = { dashboard.summary }
                    todayTasks = { dashboard.today_tasks }
                />
            </div>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "20px",
                }}
            >
                <DashboardTodayTasks
                    tasks = { dashboard.today_tasks }
                />

                <DashboardRecentActivity
                    activities = { dashboard.recent_activities }
                />
            </div>
        </>
    );
};

export default CATeamsDashboard;
